import {Box} from '@chakra-ui/react';
import {useEffect, useState} from 'react';
import {MarketplaceHeaderWidget} from '../marketplace/widgets/marketplace-header-widget';
import {MarketAvailabilityWidget} from '../marketplace/widgets/market-availability-widget';
import {useTransactionDrawerContext} from '../../context/transaction-drawer';
import {useGetActiveListingsQuery, Listing} from '../../graphql/generated';

interface MarketplaceWidgetsProps {
  color: string;
  assetId: string;
  totalPieces: number;
  marketplaceAveragePrice: number;
  availabilityWidgetButton?: () => void;
}

export const MarketplaceWidgets: React.FC<MarketplaceWidgetsProps> = ({
  color,
  assetId,
  totalPieces,
  marketplaceAveragePrice,
  availabilityWidgetButton,
}) => {
  const [marketplaceActiveListings, setMarketplaceActiveListings] = useState<
    Listing[] | null
  >(null);

  const {openDrawer, isActive, isLoading} = useTransactionDrawerContext();
  const {refetch, data, loading} = useGetActiveListingsQuery({
    variables: {assetId},
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    refetchWritePolicy: 'overwrite',
  });

  useEffect(() => {
    if (!isActive || isLoading) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, isLoading]);

  useEffect(() => {
    if (!loading) {
      setMarketplaceActiveListings(
        (data?.getActiveListings as Listing[]) || null,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <>
      <MarketplaceHeaderWidget
        color={color}
        title="Marketplace"
        startingPrice={(marketplaceActiveListings
          ? marketplaceActiveListings.reduce((prev: number, curr: Listing) => {
              if (prev === 0) return curr.price.value;
              if (curr.price.value < prev) return curr.price.value;
              return prev;
            }, 0)
          : 0
        ).toString()}
      />
      <Box my={2}>
        <MarketAvailabilityWidget
          color={color}
          totalPieces={totalPieces}
          averagePiecePrice={marketplaceAveragePrice}
          scrollHandler={availabilityWidgetButton && availabilityWidgetButton}
          handleDrawer={() => openDrawer && openDrawer('priceAlert', assetId)}
          piecesAvailable={
            marketplaceActiveListings
              ? marketplaceActiveListings.reduce(
                  (prev: number, curr: Listing) => {
                    return prev + curr.quantityAvailable;
                  },
                  0,
                )
              : 0
          }
        />
      </Box>
    </>
  );
};
